import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { PortionMaterialSizeDescriptionField } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

//Used for the coarsest portion, which is at path WholePortion.Separation.CoarsePortion
let CoarsePortionSievingMassesSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  const wholePortionPrefix = namePrefix!.substring(0, namePrefix!.lastIndexOf('WholePortion') + 'WholePortion'.length);
  const isWholePortionWashed = useSelector(
    pipe(createWorksheetSelector!(`${wholePortionPrefix}.Washing.IsWashed`, false), valueOrDefault(false))
  );

  const isCoarsePortionWashed = useSelector(pipe(createWorksheetSelector!(`Washing.IsWashed`), valueOrDefault(false)));

  const isInitialSeparationPerformed = useSelector(
    pipe(createWorksheetSelector!(`data.Preparation.InitialSeparationPerformed`, false), valueOrDefault(false))
  );

  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      <NamePrefixModifier namePrefix={wholePortionPrefix}>
        <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />
        {/* Standard or AnnexB */}
        <Field
          input={<TextOutput />}
          name="Washing.WashedDryMass"
          visible={isWholePortionWashed}
          label="Sieve Portion Washed Material Dry Mass"
        />
      </NamePrefixModifier>
      {/* AnnexA */}
      <Field
        input={<TextOutput />}
        name="Washing.WashedDryMass"
        label="Sieve Portion Washed Material Dry Mass"
        visible={isInitialSeparationPerformed && isCoarsePortionWashed}
      />
    </ListFieldSection>
  );
};
CoarsePortionSievingMassesSection = withInjectedProps(CoarsePortionSievingMassesSection);

export { CoarsePortionSievingMassesSection };
export default CoarsePortionSievingMassesSection;
